import React from "react";
import { forceDownload } from "../../util/Flag";
import Button from "./Button";

// File type checks
const isImage = (val) => /\.(jpeg|jpg|png|gif|webp)$/i.test(val);
const isVideo = (val) => /\.(mp4|webm|ogg)$/i.test(val);
const isPDF = (val) => /\.pdf$/i.test(val);
const isWordDoc = (val) => /\.(doc|docx)$/i.test(val);

const dummyFileIcon = "https://cdn-icons-png.flaticon.com/512/2991/2991108.png";

// Use Google Docs Viewer for Word documents
const getViewUrl = (url) => {
  if (isWordDoc(url)) {
    return `https://docs.google.com/viewer?url=${encodeURIComponent(
      url
    )}&embedded=true`;
  }
  return url;
};

const SmartFieldRenderer = ({ label, value, isFront }) => {
  if (!value) return null;

  const filename = value.split("/").pop().split("?")[0] || "download";

  const renderButtons = (url, name = "file") => {
    if (isFront) return null;

    return (
      <div className="flex gap-2 mt-2">
        <Button
          buttonClasses="!my-2"
          buttonFunction={() => window.open(getViewUrl(url), "_blank")}
          buttonLabel="View"
        />
        <Button
          buttonClasses="!my-2"
          buttonFunction={() => forceDownload(url, name)}
          buttonLabel="Download"
        />
      </div>
    );
  };

  const renderFileRow = (url, type = "File") => (
    <div className="flex items-center gap-2 mt-2">
      <img src={dummyFileIcon} alt={type} style={{ width: "30px" }} />
      <span>{type}</span>
      {renderButtons(url, filename)}
    </div>
  );

  return (
    <div className="mb-4">
      <strong>{label}: </strong>
      {typeof value === "string" && value.startsWith("http") ? (
        isImage(value) ? (
          <div>
            <img
              src={value}
              alt={label}
              style={{ width: "100%", height: "400px", objectFit: "contain" }}
            />
            {renderFileRow(value, "Image")}
          </div>
        ) : isVideo(value) ? (
          renderFileRow(value, "Video")
        ) : isPDF(value) ? (
          renderFileRow(value, "PDF")
        ) : isWordDoc(value) ? (
          renderFileRow(value, "Word Document")
        ) : (
          renderFileRow(value, "File")
        )
      ) : (
        <span>{value}</span>
      )}
    </div>
  );
};

export default SmartFieldRenderer;
